export default {"src":"/_next/static/media/address-right.0ddffe7d.svg","height":2,"width":197,"blurWidth":0,"blurHeight":0};